<template>
  <div>
    <transition name="fade" mode="out-in">
      <Retire_1 v-if="retire_1" key="1"></Retire_1>
      <Retire_2 v-if="retire_2" key="2"></Retire_2>
      <Retire_3 v-if="retire_3" key="3"></Retire_3>
      <Retire_4 v-if="retire_4" key="4"></Retire_4>
      <Retire_5 v-if="retire_5" key="5"></Retire_5>
      <Retire_form v-if="retire_form"></Retire_form>
    </transition>
  </div>
</template>

<script>
import '@/assets/css/scenario_retire.css'
import Retire_1 from '../../components/retire/retire_1';
import Retire_2 from '../../components/retire/retire_2';
import Retire_3 from '../../components/retire/retire_3';
import Retire_4 from '../../components/retire/retire_4';
import Retire_5 from '../../components/retire/retire_5';
import Retire_form from '../../components/retire/retire_form';
import { get, sync, call } from 'vuex-pathify'


export default {
  name: "retire",
  components: {
    Retire_1,
    Retire_2,
    Retire_3,
    Retire_4,
    Retire_5,
    Retire_form
  },
  data: function () {
    return {
      defaultShow: {
        retire_1: true,
        retire_2: false,
        retire_3: false,
        retire_4: false,
        retire_5: false,
        retire_form: false,
      },
      defaultCost: {},
      show: {},
      defaultInterestsCost: 0,
      defaultOptions: {}
    }
  },
  methods: {
    setShow() {
      this.show = this.getShow
    },
  },
  computed: {
    ...sync('retire@show', {
      retire_1: 'retire_1',
      retire_2: 'retire_2',
      retire_3: 'retire_3',
      retire_4: 'retire_4',
      retire_5: 'retire_5',
      retire_form: 'retire_form',
    }),
    getShow: get('retire/show'),
  },
  created() {
    this.setShow()
  }
}
</script>

